export default class TeamAddController {
    constructor($scope, $state, ApiTeam, $ionicPopup, $ionicLoading, $stateParams, MessageBox) {
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.ApiTeam = ApiTeam;
        this.MessageBox = MessageBox;
        this.data = null; // encapsulated object
        this.members = null; // members of the currently selected team
        this.editFlag = false; // flag set to true when the data is to be edited
        this.teamLoaded = false; // flag to indicate that team data has been fetched from database
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });

        this.ApiTeam.getTeams().then((res) => {
            if (typeof res != 'undefined') {
                this.data = res || {};
                this.editFlag = res !== null;
                this.teamLoaded = true;
            }
            this.$ionicLoading.hide();
        });
    }

    saveTeam() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });

        if (this.editFlag) {
            this.ApiTeam.putTeam(this.data).then((result) => {
                this.$ionicLoading.hide();
                this.$state.go('teamDetail');
            });
        } else {
            this.data.groupStatus = 'ENABLED';
            this.ApiTeam.postTeam(this.data).then((result) => {
                this.$ionicLoading.hide();
                this.$state.go('teamDetail');
            });
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/team/teamAdd.controller.js
 **/